import { Controller } from "@hotwired/stimulus"

// Thin wrapper over native <dialog> elements. open() shows one as a modal; close() dismisses.
// Supports MULTIPLE dialogs under one controller (e.g. the admin Actions menu, where each
// input-taking action gets its own modal): pass the target's name via the `name` action param
// (data-dialog-name-param) and tag each <dialog> with data-dialog-name. With no name it falls
// back to the sole dialog — so the single-modal usage (company "Report Issue") is unchanged.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    const name = event?.params?.name
    const dialog = name
      ? this.dialogTargets.find((d) => d.dataset.dialogName === name)
      : this.dialogTarget
    dialog?.showModal()
  }

  close(event) {
    // Close the dialog the Cancel button lives in (or the only one, for a backdrop/programmatic call).
    const dialog = event?.target?.closest?.("dialog")
    if (dialog) dialog.close()
    else this.dialogTargets.forEach((d) => d.close())
  }
}
